import { graphql, useStaticQuery } from 'gatsby';

export default function useSiteMetadata() {
  const data = useStaticQuery(graphql`
    query SEOComponent {
      site {
        siteMetadata {
          title
          author {
            name
          }
          keywords
          description
          siteUrl
          social {
            fbAppId
            twitter
          }
          thumbnailUrl
        }
      }
    }
  `);

  return (data as Queries.SEOComponentQuery)?.site?.siteMetadata;
}
